var map = {
	"./address-full.svg": 853,
	"./address.svg": 365,
	"./agendar.svg": 515,
	"./card.svg": 265,
	"./cellphone.svg": 937,
	"./cupom-full.svg": 369,
	"./cupom-sacola.svg": 101,
	"./cupom.svg": 81,
	"./delivery.svg": 171,
	"./drive-thru.svg": 65,
	"./edit.svg": 71,
	"./gps.svg": 53,
	"./help.svg": 842,
	"./home-full.svg": 84,
	"./home.svg": 238,
	"./information-full.svg": 307,
	"./information.svg": 163,
	"./local.svg": 284,
	"./map.svg": 167,
	"./pedido-full.svg": 198,
	"./pedido.svg": 672,
	"./perfil-full.svg": 477,
	"./perfil.svg": 397,
	"./pontos-full.svg": 486,
	"./pontos.svg": 512,
	"./promocao-full.svg": 371,
	"./promocao.svg": 883,
	"./qrcode.svg": 129,
	"./retirada.svg": 431,
	"./sacola-full.svg": 422,
	"./sacola.svg": 296,
	"./search.svg": 999,
	"./success.svg": 20,
	"./viagem.svg": 546,
	"./whatsapp.svg": 945,
	"./work.svg": 228
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 184;